/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import { AppContext } from '../providers/AppContext';
import { useContext } from 'react';

export function Hitbox(props) {
  const { nodes } = useGLTF('/models/hitbox.glb')

  const { setShowModal } = useContext(AppContext);

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Hitbox_Movie_Poster.geometry}
        material={nodes.Hitbox_Movie_Poster.material}
        position={[-0.781, 0.643, -3.858]}
        rotation={[0, -0.701, 0]}
        scale={[0.411, 0.505, 0.202]}
        visible={false}
        onClick={() => {
          setShowModal({
            type: 'poster',
            imageSource: '/images/poster.webp'
          })
        }}
        onPointerOver={() => {
            document.body.style.cursor = "pointer";
        }}
        onPointerOut={() => {
            document.body.style.cursor = "auto";
        }}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Hitbox_Teaser_Trailer.geometry}
        material={nodes.Hitbox_Teaser_Trailer.material}
        position={[1.698, 0.738, -3.342]}
        rotation={[0, -0.701, 0]}
        scale={[0.411, 0.505, 0.202]}
        visible={false}
        onClick={() => {
          setShowModal({
            type: 'trailer',
            embedLink: 'https://www.youtube.com/embed/R5l1wOl7lqg?si=RxuTA6mlgzknugNi'
          });
        }}
        onPointerOver={() => {
            document.body.style.cursor = "pointer";
        }}
        onPointerOut={() => {
            document.body.style.cursor = "auto";
        }}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Hitbox_Official_Trailer.geometry}
        material={nodes.Hitbox_Official_Trailer.material}
        position={[3.3, 0.738, 2.001]}
        rotation={[0, -1.275, 0]}
        scale={[0.411, 0.505, 0.202]}
        visible={false}
        onClick={() => {
          setShowModal({
            type: 'trailer',
            embedLink: 'https://www.youtube.com/embed/K3jH6Wb3WNM?si=Y5qe83ny731XCam5'
          });
        }}
        onPointerOver={() => {
            document.body.style.cursor = "pointer";
        }}
        onPointerOut={() => {
            document.body.style.cursor = "auto";
        }}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Hitbox_Final_Trailer.geometry}
        material={nodes.Hitbox_Final_Trailer.material}
        position={[2.724, 0.715, 4.043]}
        rotation={[Math.PI, -1.351, Math.PI]}
        scale={[0.411, 0.505, 0.202]}
        visible={false}
        onClick={() => {
          setShowModal({
            type: 'trailer',
            embedLink: 'https://www.youtube.com/embed/Z_G2cU5-vSk?si=qFyKIH-_92EXe37C'
          });
        }}
        onPointerOver={() => {
            document.body.style.cursor = "pointer";
        }}
        onPointerOut={() => {
            document.body.style.cursor = "auto";
        }}
      />
    </group>
  )
}

useGLTF.preload('/models/hitbox.glb')
